import logo from "./favicon.svg";

export default function App() {
  return (
    <>
      <header>
        <a className="wordmark" href="#">
          <img className="logo" src={logo} alt="" width="32" height="32" />
          UndefX
        </a>
        <a className="nav-link" href="mailto:contact@undefx.com">Contact</a>
      </header>

      <main>
        <h1>Defining the undefined&nbsp;— bringing AI to the real&nbsp;world.</h1>
        <p className="contact">
          Get in touch<br />
          <a href="mailto:contact@undefx.com">contact@undefx.com</a>
        </p>
      </main>

      <footer>© 2026 UndefX</footer>
    </>
  );
}
